import debug from 'debug'

/**
 * Creates a Debug instance
 * @param namespace - Name of the debug instance
 */
export function Debug(namespace: string): debug.Debugger {
  return debug(`io:ugc:${namespace}`)
}
